// Status -> colour map from REACT_APP_STATUS_DATA (a JSON object baked in at
// build time). It used to be JSON.parse'd bare at module load, so a missing or
// malformed value threw while the bundle was being evaluated and blanked the
// whole admin app. Fall back to {} instead; callers already default each
// lookup to "#000".
export function parseStatusData(raw = process.env.REACT_APP_STATUS_DATA) {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch (error) {
    console.error("REACT_APP_STATUS_DATA is not valid JSON; using {}", error);
    return {};
  }
}

export const STATUS_DATA = parseStatusData();
